    <mat-toolbar _ngcontent-fgg-c233="" class="mat-toolbar mat-toolbar-single-row">{{ 'changePassword' | translate}}</mat-toolbar>
    <mat-card class="mat-margin" >

    <form fxLayout="row wrap" fxLayoutAlign="space-between none" class="form-signin p-15" [formGroup]="form">
       
            <div fxFlex="96">
                <mat-form-field class="form-group" appearance="outline">
                    <mat-label>{{ 'oldPassword' | translate}}</mat-label>
                    <input type="password" matInput placeholder="{{ 'oldPassword' | translate}}" class="form-control"
                        [type]="isHidden1 ? 'password' : 'text'" formControlName="usrOldPassword" autocomplete="off">
                    <mat-icon matSuffix (click)="isHidden1 = !isHidden1">{{ isHidden1 ? 'visibility_off' : 'visibility'}}
                    </mat-icon>
                </mat-form-field>
                <ng-container *ngIf="form.controls['usrOldPassword'].invalid && form.controls['usrOldPassword'].value.length>0">
                    <mat-error *ngIf="form.controls['usrOldPassword'].errors.required">
                        {{ "required" | translate }}
                    </mat-error>
                </ng-container>
                <!-- <div fxLayout="column" *ngIf="form.controls['usrOldPassword'].hasError('required')  || form.controls['usrOldPassword'].hasError('minlength')  || form.controls['usrOldPassword'].hasError('hasNumber')  || form.controls['usrOldPassword'].hasError('hasCapitalCase') || form.controls['usrOldPassword'].hasError('hasSmallCase')  || form.controls['usrOldPassword'].hasError('hasSpecialCharacters')">
                    <label
                    [ngClass]="form.controls['usrOldPassword'].hasError('required') || form.controls['usrOldPassword'].hasError('minlength')  ? 'text-danger' : 'text-success'">
                    <i class="material-icons">{{ form.controls['usrOldPassword'].hasError('required') ||
                        form.controls['usrOldPassword'].hasError('minlength') ? 'cancel' :
                        'check_circle' }}</i>
                        {{ "error.8char" | translate }}
                    </label>
                    <label
                    [ngClass]="form.controls['usrOldPassword'].hasError('required') || form.controls['usrOldPassword'].hasError('hasNumber')  ? 'text-danger' : 'text-success'">
                    <i class="material-icons">{{ form.controls['usrOldPassword'].hasError('required') ||
                        form.controls['usrOldPassword'].hasError('hasNumber') ? 'cancel' :
                        'check_circle' }}</i>
                        {{ "error.1num" | translate }}
                    </label>
                    <label
                    [ngClass]="form.controls['usrOldPassword'].hasError('required') || form.controls['usrOldPassword'].hasError('hasCapitalCase')  ? 'text-danger' : 'text-success'">
                    <i class="material-icons">{{ form.controls['usrOldPassword'].hasError('required') ||
                        form.controls['usrOldPassword'].hasError('hasCapitalCase') ? 'cancel' :
                        'check_circle' }}</i>
                        {{ "error.1cap" | translate }}
                    </label>
                    <label
                    [ngClass]="form.controls['usrOldPassword'].hasError('required') || form.controls['usrOldPassword'].hasError('hasSmallCase')  ? 'text-danger' : 'text-success'">
                    <i class="material-icons">{{ form.controls['usrOldPassword'].hasError('required') ||
                        form.controls['usrOldPassword'].hasError('hasSmallCase') ? 'cancel' :
                        'check_circle' }}</i>
                        {{ "error.1small" | translate }}
                    </label>
                    <label
                    [ngClass]="form.controls['usrOldPassword'].hasError('required') || form.controls['usrOldPassword'].hasError('hasSpecialCharacters') ? 'text-danger' : 'text-success'">
                    <i class="material-icons">{{ form.controls['usrOldPassword'].hasError('required') ||
                        form.controls['usrOldPassword'].hasError('hasSpecialCharacters') ? 'cancel' :
                        'check_circle' }}</i>
                        {{ "error.1spec" | translate }}
                    </label>
                </div> -->
            </div>

            <div fxFlex="96">
                <mat-form-field class="form-group" appearance="outline">
                    <mat-label>{{ 'newPassword' | translate}}</mat-label>
                    <input type="password" matInput placeholder="{{ 'newPassword' | translate}}" class="form-control"
                        [type]="isHidden2 ? 'password' : 'text'" formControlName="usrPassword" autocomplete="off">
                    <mat-icon matSuffix (click)="isHidden2 = !isHidden2">{{ isHidden2 ? 'visibility_off' : 'visibility'}}
                    </mat-icon>
                </mat-form-field>
                <div fxLayout="column" *ngIf="form.controls['usrPassword'].hasError('required')  || form.controls['usrPassword'].hasError('minlength')  || form.controls['usrPassword'].hasError('hasNumber')  || form.controls['usrPassword'].hasError('hasCapitalCase') || form.controls['usrPassword'].hasError('hasSmallCase')  || form.controls['usrPassword'].hasError('hasSpecialCharacters')">
                    <label
                    [ngClass]="form.controls['usrPassword'].hasError('required') || form.controls['usrPassword'].hasError('minlength')  ? 'text-danger' : 'text-success'">
                    <i class="material-icons">{{ form.controls['usrPassword'].hasError('required') ||
                        form.controls['usrPassword'].hasError('minlength') ? 'cancel' :
                        'check_circle' }}</i>
                        {{ "error.8char" | translate }}
                    </label>
                    <label
                    [ngClass]="form.controls['usrPassword'].hasError('required') || form.controls['usrPassword'].hasError('hasNumber')  ? 'text-danger' : 'text-success'">
                    <i class="material-icons">{{ form.controls['usrPassword'].hasError('required') ||
                        form.controls['usrPassword'].hasError('hasNumber') ? 'cancel' :
                        'check_circle' }}</i>
                        {{ "error.1num" | translate }}
                    </label>
                    <label
                    [ngClass]="form.controls['usrPassword'].hasError('required') || form.controls['usrPassword'].hasError('hasCapitalCase')  ? 'text-danger' : 'text-success'">
                    <i class="material-icons">{{ form.controls['usrPassword'].hasError('required') ||
                        form.controls['usrPassword'].hasError('hasCapitalCase') ? 'cancel' :
                        'check_circle' }}</i>
                        {{ "error.1cap" | translate }}
                    </label>
                    <label
                    [ngClass]="form.controls['usrPassword'].hasError('required') || form.controls['usrPassword'].hasError('hasSmallCase')  ? 'text-danger' : 'text-success'">
                    <i class="material-icons">{{ form.controls['usrPassword'].hasError('required') ||
                        form.controls['usrPassword'].hasError('hasSmallCase') ? 'cancel' :
                        'check_circle' }}</i>
                        {{ "error.1small" | translate }}
                    </label>
                    <label
                    [ngClass]="form.controls['usrPassword'].hasError('required') || form.controls['usrPassword'].hasError('hasSpecialCharacters') ? 'text-danger' : 'text-success'">
                    <i class="material-icons">{{ form.controls['usrPassword'].hasError('required') ||
                        form.controls['usrPassword'].hasError('hasSpecialCharacters') ? 'cancel' :
                        'check_circle' }}</i>
                        {{ "error.1spec" | translate }}
                    </label>
                </div>
            </div>
            <div fxFlex="96">
                <mat-form-field class="form-group" appearance="outline">
                    <mat-label>{{ 'confirmPassword' | translate}}</mat-label>
                    <input type="password" matInput placeholder="{{ 'confirmPassword' | translate}}" class="form-control"
                        [type]="isHidden3 ? 'password' : 'text'" formControlName="usrConfirmPassword" autocomplete="off">
                    <mat-icon matSuffix (click)="isHidden3 = !isHidden3">{{ isHidden3 ? 'visibility_off' : 'visibility'}}
                    </mat-icon>
                </mat-form-field>
                <div fxLayout="column" *ngIf="form.controls['usrConfirmPassword'].hasError('required')  || form.controls['usrConfirmPassword'].hasError('minlength')  || form.controls['usrConfirmPassword'].hasError('hasNumber')  || form.controls['usrConfirmPassword'].hasError('hasCapitalCase') || form.controls['usrConfirmPassword'].hasError('hasSmallCase')  || form.controls['usrConfirmPassword'].hasError('hasSpecialCharacters')">
                    <label
                    [ngClass]="form.controls['usrConfirmPassword'].hasError('required') || form.controls['usrConfirmPassword'].hasError('minlength')  ? 'text-danger' : 'text-success'">
                    <i class="material-icons">{{ form.controls['usrConfirmPassword'].hasError('required') ||
                        form.controls['usrConfirmPassword'].hasError('minlength') ? 'cancel' :
                        'check_circle' }}</i>
                        {{ "error.8char" | translate }}
                    </label>
                    <label
                    [ngClass]="form.controls['usrConfirmPassword'].hasError('required') || form.controls['usrConfirmPassword'].hasError('hasNumber')  ? 'text-danger' : 'text-success'">
                    <i class="material-icons">{{ form.controls['usrConfirmPassword'].hasError('required') ||
                        form.controls['usrConfirmPassword'].hasError('hasNumber') ? 'cancel' :
                        'check_circle' }}</i>
                        {{ "error.1num" | translate }}
                    </label>
                    <label
                    [ngClass]="form.controls['usrConfirmPassword'].hasError('required') || form.controls['usrConfirmPassword'].hasError('hasCapitalCase')  ? 'text-danger' : 'text-success'">
                    <i class="material-icons">{{ form.controls['usrConfirmPassword'].hasError('required') ||
                        form.controls['usrConfirmPassword'].hasError('hasCapitalCase') ? 'cancel' :
                        'check_circle' }}</i>
                        {{ "error.1cap" | translate }}
                    </label>
                    <label
                    [ngClass]="form.controls['usrConfirmPassword'].hasError('required') || form.controls['usrConfirmPassword'].hasError('hasSmallCase')  ? 'text-danger' : 'text-success'">
                    <i class="material-icons">{{ form.controls['usrConfirmPassword'].hasError('required') ||
                        form.controls['usrConfirmPassword'].hasError('hasSmallCase') ? 'cancel' :
                        'check_circle' }}</i>
                        {{ "error.1small" | translate }}
                    </label>
                    <label
                    [ngClass]="form.controls['usrConfirmPassword'].hasError('required') || form.controls['usrConfirmPassword'].hasError('hasSpecialCharacters') ? 'text-danger' : 'text-success'">
                    <i class="material-icons">{{ form.controls['usrConfirmPassword'].hasError('required') ||
                        form.controls['usrConfirmPassword'].hasError('hasSpecialCharacters') ? 'cancel' :
                        'check_circle' }}</i>
                        {{ "error.1spec" | translate }}
                    </label>
                </div>
            </div>
            <div fxFlex="96">
                <mat-dialog-actions align="center">
                    <button mat-button mat-dialog-close>{{ "cancel" | translate }}</button>
                    <button mat-button color="primary" (click)="changePassword()"> {{ "changePassword" | translate }}</button>
                  </mat-dialog-actions>
            </div>
    </form>
</mat-card>

